import { render } from "./ButtonRefineBase.vue?vue&type=template&id=4076bf9e&scoped=true&ts=true"
import script from "./ButtonRefineBase.vue?vue&type=script&lang=ts"
export * from "./ButtonRefineBase.vue?vue&type=script&lang=ts"

import "./ButtonRefineBase.vue?vue&type=style&index=0&id=4076bf9e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4076bf9e"]])

export default __exports__